import { IPersonalInfo, InputFieldConfig } from '../../../../../types';
import { StudentState } from '../../../../../store/student/types';

type Fields = Pick<IPersonalInfo, 'passportNumber' | 'passportStatus' | 'passportExpiryDate' | 'passportExpectedDate'>;

type Visible = Record<'passportNumber' | 'passportStatus' | 'passportExpiryDate' | 'passportExpectedDate', boolean>;

type Mandatory = Record<'passportNumber' | 'passportStatus' | 'passportExpiryDate' | 'passportExpectedDate', boolean>;

const passportStatusLabels: { [key: string]: string } = {
  Yes: 'Yes, I have a passport',
  Applied: 'No, I have already applied for one',
  GoingToApply: 'No, I will apply for one',
};

export function passportStatusLabel(value: string | undefined) {
  return passportStatusLabels[value ?? ''] ?? '';
}

export function getPageStatus(
  config: StudentState['config'],
  fields: Fields,
): {
  complete: boolean;
  visible: Visible;
} {
  const { passportStatus, passportNumber, passportExpectedDate, passportExpiryDate } = fields;

  const {
    PassportNumber: passportNumberConfig,
    PassportStatus: passportStatusConfig,
    PassportExpectedDate: passportExpectedDateConfig,
    PassportExpiryDate: passportExpiryDateConfig,
  }: {
    PassportNumber: InputFieldConfig;
    PassportStatus: InputFieldConfig;
    PassportExpectedDate: InputFieldConfig;
    PassportExpiryDate: InputFieldConfig;
  } = config.Checklist.PersonalInfo.Page7;

  const visible: Visible = {
    passportStatus: passportStatusConfig?.visible ?? true,
    passportNumber: (passportNumberConfig?.visible ?? true) && passportStatus === 'Yes',
    passportExpectedDate:
      (passportExpectedDateConfig?.visible ?? true) && ['Applied', 'GoingToApply'].includes(String(passportStatus)),
    passportExpiryDate: (passportExpiryDateConfig?.visible ?? true) && passportStatus === 'Yes',
  };

  const mandatory: Mandatory = {
    passportStatus: passportStatusConfig?.mandatory ?? true,
    passportNumber: passportNumberConfig?.mandatory ?? true,
    passportExpectedDate: passportExpectedDateConfig?.mandatory ?? true,
    passportExpiryDate: passportExpiryDateConfig?.mandatory ?? true,
  };

  // prettier-ignore
  const complete =
    (!visible.passportStatus || !mandatory.passportStatus || passportStatus !== '') &&
    (!visible.passportNumber || !mandatory.passportNumber || passportNumber !== '') &&
    ((passportStatus === 'Yes' && (!visible.passportExpiryDate || !mandatory.passportExpiryDate || passportExpiryDate !== '')) ||
      (['Applied', 'GoingToApply'].includes(String(passportStatus)) && (!visible.passportExpectedDate || !mandatory.passportExpectedDate || passportExpectedDate !== '')));

  return {
    complete,
    visible,
  };
}
